import { getProxyUrl, getPublicLang } from 'academy-common-lib/utils/url';
// @ts-expect-error Could not find a declaration file for module
import defaultShareImage from 'bender-url!../../images/default-share-image.png';
// @ts-expect-error Could not find a declaration file for module
import academyLogo from 'bender-url!../../images/hubspot-academy-logo-color.svg';
import PublicPageCertificationPreview from '../features/publicPresentation/components/PublicPageCertificationPreview';
import PublicLandingPagePrimaryDetails from '../features/publicPresentation/components/PublicLandingPagePrimaryDetails';
import PublicLandingPageSecondaryDetails from '../features/publicPresentation/components/PublicLandingPageSecondaryDetails';
import PublicPageLayout from '../features/publicLayout/components/PublicPageLayout';
import PublicPageVideoSection from '../features/publicPresentation/components/PublicPageVideoSection';
import PublicPageProfessorsSection from '../features/publicPresentation/components/PublicPageProfessorsSection';
import PublicPageCurriculumSection from '../features/publicPresentation/components/PublicPageCurriculumSection';
import PublicPageRelatedContentSection from '../features/publicPresentation/components/PublicPageRelatedContentSection';
import PublicPageTranscriptSection from '../features/publicPresentation/components/PublicPageTranscriptSection';
import PublicPageAboutAcademySection from '../features/publicPresentation/components/PublicPageAboutAcademySection';
import PublicPageShareSection from '../features/publicPresentation/components/PublicPageShareSection';
import { usePublicCourse } from '../features/publicCourse/publicCourseQueries';
import { getSignupUrl } from '../utils/urls';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import { supportedPublicLanguages } from 'academy-common-lib/constants/academySupportedLanguages';
import DocumentHead from '../features/publicSeo/components/DocumentHead';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ApiError from '../components/ApiError';
import { NavMarker } from 'react-rhumb';
import OpenGraph from '../features/publicSeo/components/OpenGraph';
import I18n from 'I18n';
import { useEffect, useRef } from 'react';
import Schema from '../features/publicSeo/components/Schema';
import usageTracker from '../utils/usageTracker';
import { useIsLoggedIn } from '../features/publicLayout/publicQueries';
import { durationToSchema } from '../utils/time';
import AlternateLanguageLinks from '../features/publicSeo/components/AlternateLanguageLinks';
import HorizontalLayoutContainer from '../features/publicLayout/components/HorizontalLayoutContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublicCoursePage = ({
  match: {
    params: {
      pagePath
    }
  }
}) => {
  useEffect(() => {
    usageTracker.track('pageView', {
      screen: 'course-page',
      subscreen: pagePath
    });
  }, [pagePath]);
  const {
    publicCourse,
    publicCourseLoading,
    publicCourseError
  } = usePublicCourse(pagePath, getPublicLang());
  const {
    isLoggedIn
  } = useIsLoggedIn();
  const {
    seoCustomTeaser,
    description,
    headline,
    name,
    seoPageTitle,
    certification,
    id,
    personas,
    learnings,
    availableLanguages,
    lessons,
    contentTypeCounts,
    duration,
    subCategories,
    seoDetailedProfessorRelatedContent,
    seoDetailedRelatedContent,
    seoTranscript,
    seoTranscriptTitle,
    introVideo,
    titleTag,
    canonicalUrl,
    previewThumbnailRectangleUrl,
    seoThumbnailAltText,
    iconUrl
  } = publicCourse || {};
  const availableSupportedLanguages = (availableLanguages || []).filter(lang => supportedPublicLanguages.includes(lang));
  const browserTabTitle = titleTag || seoPageTitle || name;
  const courseDescription = (seoCustomTeaser || description || '').trim();
  useEffect(() => {
    if (browserTabTitle) {
      document.title = browserTabTitle;
    }
  }, [browserTabTitle]);
  const embeddedSignupRef = useRef(null);
  if (!publicCourse && publicCourseLoading) {
    return /*#__PURE__*/_jsx(PublicPageLayout, {
      footerType: "minimal",
      children: /*#__PURE__*/_jsx(UILoadingOverlay, {
        contextual: true,
        layout: "centered"
      })
    });
  }
  if (!publicCourse || publicCourseError) {
    var _publicCourseError$st;
    return /*#__PURE__*/_jsxs(PublicPageLayout, {
      footerType: "minimal",
      children: [window.prerenderReady = true, /*#__PURE__*/_jsx(ApiError, {
        error: publicCourseError,
        errorMarker: "COURSE_LANDING_PAGE_LOAD_FAILURE",
        forbiddenErrorMarker: "COURSE_LANDING_PAGE_FORBIDDEN",
        notFoundErrorMarker: "COURSE_LANDING_PAGE_NOT_FOUND"
      }), /*#__PURE__*/_jsx(DocumentHead, {
        children: /*#__PURE__*/_jsx("meta", {
          content: (publicCourseError === null || publicCourseError === void 0 || (_publicCourseError$st = publicCourseError.status) === null || _publicCourseError$st === void 0 ? void 0 : _publicCourseError$st.toString()) || '500',
          name: "prerender-status-code"
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(PublicPageLayout, {
    availableLanguages: availableSupportedLanguages.length ? availableSupportedLanguages : undefined,
    footerType: "minimal",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "COURSE_LANDING_PAGE_LOAD"
    }), window.prerenderReady = true, /*#__PURE__*/_jsxs(DocumentHead, {
      children: [/*#__PURE__*/_jsx("link", {
        href: getProxyUrl(`/courses/${canonicalUrl || pagePath}`),
        rel: "canonical"
      }), /*#__PURE__*/_jsx(AlternateLanguageLinks, {
        languages: availableSupportedLanguages
      }), /*#__PURE__*/_jsx("meta", {
        content: courseDescription,
        name: "description"
      }), /*#__PURE__*/_jsx(OpenGraph, {
        description: courseDescription,
        image: previewThumbnailRectangleUrl || defaultShareImage.replace('//', 'https://'),
        imageAlt: seoThumbnailAltText || I18n.text('academyPublic.defaultThumbnailAltText'),
        title: seoPageTitle || name,
        url: getProxyUrl(`/courses/${canonicalUrl || pagePath}`)
      })]
    }), /*#__PURE__*/_jsx(Schema, {
      object: {
        ['@type']: 'Course',
        name: seoPageTitle || name,
        description: courseDescription,
        isAccessibleForFree: true,
        inLanguage: getPublicLang(),
        creator: (seoDetailedProfessorRelatedContent === null || seoDetailedProfessorRelatedContent === void 0 ? void 0 : seoDetailedProfessorRelatedContent[0]) && {
          ['@type']: 'Person',
          name: seoDetailedProfessorRelatedContent[0].name
        },
        about: {
          name: I18n.text(`academyPublic.categories.${subCategories === null || subCategories === void 0 ? void 0 : subCategories[0]}`)
        },
        provider: {
          ['@type']: 'Organization',
          name: 'HubSpot Academy',
          sameAs: 'https://academy.hubspot.com',
          logo: academyLogo.replace('//', 'https://')
        },
        timeRequired: duration ? durationToSchema(duration) : undefined,
        hasCourseInstance: [{
          '@type': 'CourseInstance',
          courseMode: 'Online',
          courseWorkload: duration ? durationToSchema(duration) : undefined,
          instructor: {
            '@type': 'Person',
            name: seoDetailedProfessorRelatedContent === null || seoDetailedProfessorRelatedContent === void 0 ? void 0 : seoDetailedProfessorRelatedContent[0].name,
            description: courseDescription,
            image: seoDetailedProfessorRelatedContent === null || seoDetailedProfessorRelatedContent === void 0 ? void 0 : seoDetailedProfessorRelatedContent[0].professorImage
          }
        }],
        offers: {
          '@type': 'Offer',
          category: 'Free'
        }
      }
    }), /*#__PURE__*/_jsxs(HorizontalLayoutContainer, {
      children: [/*#__PURE__*/_jsx(PublicLandingPagePrimaryDetails, {
        contentType: certification ? 'CERTIFICATION' : 'TRACK',
        description: seoCustomTeaser || description,
        headline: headline,
        id: id,
        name: seoPageTitle || name,
        pagePath: pagePath,
        ref: embeddedSignupRef
      }), /*#__PURE__*/_jsx(PublicLandingPageSecondaryDetails, {
        availableLanguages: availableSupportedLanguages,
        contentType: certification ? 'CERTIFICATION' : 'TRACK',
        duration: duration,
        embeddedSignupRef: embeddedSignupRef,
        exerciseCount: contentTypeCounts && contentTypeCounts.PRACTICAL_EXERCISE_FLOW,
        learnings: learnings,
        lessonCount: lessons && lessons.length,
        personas: personas,
        quizCount: contentTypeCounts && contentTypeCounts.QUIZ,
        subCategories: subCategories,
        videoCount: contentTypeCounts && contentTypeCounts.VIDEO
      }), certification && name && iconUrl && /*#__PURE__*/_jsx(PublicPageCertificationPreview, {
        iconUrl: iconUrl,
        title: name
      }), introVideo && introVideo.reference && introVideo.referenceType && /*#__PURE__*/_jsx(PublicPageVideoSection, {
        creatorHubId: introVideo.hubId || undefined,
        videoId: introVideo.reference
      }), seoDetailedProfessorRelatedContent && !!seoDetailedProfessorRelatedContent.length && /*#__PURE__*/_jsx(PublicPageProfessorsSection, {
        contentType: "TRACK",
        professors: seoDetailedProfessorRelatedContent,
        trackId: id
      }), lessons && !!lessons.length && /*#__PURE__*/_jsx(PublicPageCurriculumSection, {
        items: lessons.filter(lesson => {
          var _lesson$lessonType;
          return ((_lesson$lessonType = lesson.lessonType) === null || _lesson$lessonType === void 0 ? void 0 : _lesson$lessonType[0]) === 'LESSON';
        }).map(lesson => {
          var _lesson$seoDetailedPr;
          return {
            id: lesson.id,
            name: lesson.name,
            description: lesson.description,
            thumbnailUrl: lesson.previewThumbnailSquareUrl,
            href: isLoggedIn ? `https://app.hubspot.com/academy/l/tracks/${publicCourse.id}/${lesson.id}` : getSignupUrl('COURSE', id),
            duration: lesson.duration,
            instructorName: (_lesson$seoDetailedPr = lesson.seoDetailedProfessorRelatedContent) === null || _lesson$seoDetailedPr === void 0 || (_lesson$seoDetailedPr = _lesson$seoDetailedPr[0]) === null || _lesson$seoDetailedPr === void 0 ? void 0 : _lesson$seoDetailedPr.name,
            landingPageUrl: lesson.pagePath && lesson.visibleOnLoggedOutPage ? getProxyUrl(`/lessons/${lesson.pagePath}`) : null
          };
        })
      }), seoDetailedRelatedContent && !!seoDetailedRelatedContent.length && /*#__PURE__*/_jsx(PublicPageRelatedContentSection, {
        items: seoDetailedRelatedContent
      }), seoTranscript && /*#__PURE__*/_jsx(PublicPageTranscriptSection, {
        contentType: "TRACK",
        title: seoTranscriptTitle || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.transcript.title",
          options: {
            contentTitle: name
          }
        }),
        transcript: seoTranscript
      }), /*#__PURE__*/_jsx(PublicPageAboutAcademySection, {}), /*#__PURE__*/_jsx(PublicPageShareSection, {
        contentType: "TRACK"
      })]
    })]
  });
};
export default PublicCoursePage;